import { render, staticRenderFns } from "./CustomerDetailsData.vue?vue&type=template&id=6594c7ba&scoped=true&"
import script from "./CustomerDetailsData.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsData.vue?vue&type=style&index=0&id=6594c7ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6594c7ba",
  null
  
)

export default component.exports